import exceljs from "exceljs";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    mimeTypeMap, 
    MyDate
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Export({
    projects
}){
    const user = useMyStore(state => state.user);
    const exportFunc = () => {
        if(!projects.length){
            window.alert("No data to export.");
            return;
        }
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        const worksheet = workbook.addWorksheet("My Sheet", {views: [{showGridLines: false}]});
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 22.57;
        const rows = [];
        projects.forEach(post => {rows.push([
            post.projectNumber, // 1
            post.organizationName, // 2
            post.clientProjectNumber, // 3
            post.projectManager, // 4
            post.pipeline, // 5
            post.subPipeline, // 6
            post.stage, // 7
            post.prevailing, // 8
            post.cpr, // 9
            //-----------------
            post.location, // 10
            post.opportunityName, // 11
            post.requestor, // 12
            post.clientPONumber, // 13
            post.region, // 14
            post.creator, // 15
            new Date(post.projectCreationDate?.replace(/-/g, "/")), // 16
            post.updater, // 17
            post.projectDateUpdated?new Date(post.projectDateUpdated?.replace(/-/g, "/")):"", // 18
            post.projectDescription, // 19 // html
            post.projectNotes, // 20 // html
            post.accurateTime, // 21
            post.clientSignatureRequired, // 22
            post.sendToClient, // 23
            post.reportLink, // 24
            //--------------------
            window.Number.parseFloat(post.budget || "0"), // 25
            window.Number.parseFloat(post.laborHours || "0"), // 26
            window.Number.parseFloat(post.rate || "0"), // 27
            window.Number.parseFloat(post.materialCost || "0"), // 28
            window.Number.parseFloat(post.profit || "0"), // 29
        ]);});
        worksheet.addTable({
            name: "MyTable",
            ref: "A1",
            totalsRow: true,
            style: {
                showRowStripes: true,
            },
            columns: [
                { name: "Project Number", filterButton: true}, // 1
                { name: "Client Name", filterButton: true}, // 2
                { name: "Client Project Name / Job Number / PM Number", filterButton: true}, // 3
                { name: "Project Manager", filterButton: true}, // 4
                { name: "Pipeline", filterButton: true}, // 5
                { name: "Sub Pipeline", filterButton: true}, // 6
                { name: "Stage", filterButton: true}, // 7
                { name: "Prevailing Job", filterButton: true}, // 8
                { name: "CPR", filterButton: true}, // 9
                //--------------------
                { name: "Location", filterButton: true}, // 10
                { name: "Opportunity Name", filterButton: true}, // 11
                { name: "Requestor", filterButton: true}, // 12
                { name: "Client PO", filterButton: true}, // 13
                { name: "Region", filterButton: true}, // 14
                { name: "Creator", filterButton: true}, // 15
                { name: "Date Created", filterButton: true}, // 16
                { name: "Updater", filterButton: true}, // 17
                { name: "Date Updated", filterButton: true}, // 18
                { name: "Description", filterButton: true}, // 19
                { name: "Notes", filterButton: true}, // 20
                { name: "Accurate Time", filterButton: true}, // 21
                { name: "Client Signature Required", filterButton: true}, // 22
                { name: "Send To Client", filterButton: true}, // 23
                { name: "Report Link", filterButton: true}, // 24
                //--------------------
                { name: "Budget", filterButton: true, totalsRowFunction: "sum"}, // 25
                { name: "Labor Hours", filterButton: true}, // 26
                { name: "Rate", filterButton: true}, // 27
                { name: "Material Cost", filterButton: true, totalsRowFunction: "sum"}, // 28
                { name: "Profit", filterButton: true, totalsRowFunction: "sum"} // 29
            ],
            rows: rows,
        });
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), `projects export ${(new MyDate()).s()}.xlsx`);
        })
    }
    return(
        <span className = "pointer" onClick = {exportFunc}>
            Export
        </span>
    )
};